import React, { useState, useEffect, createContext, useContext } from "react";
import { MdDownloadForOffline } from "react-icons/md";
// Create a context with default values
const InstallContext = createContext({
  deferredPrompt: null,
  setDeferredPrompt: () => {},
  isInstallable: false,
  setIsInstallable: () => {},
});

export const InstallProvider = ({ children }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);

  return (
    <InstallContext.Provider
      value={{
        deferredPrompt,
        setDeferredPrompt,
        isInstallable,
        setIsInstallable,
      }}
    >
      {children}
    </InstallContext.Provider>
  );
};

const FooterAppButton = (props) => {
  const [isIOS, setIsIOS] = useState(false);
  const { deferredPrompt, setDeferredPrompt, isInstallable, setIsInstallable } =
    useContext(InstallContext);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    // Detect if the user is on iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(userAgent)) {
      setIsIOS(true);
    } else {
      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    }

    // Cleanup the event listener
    return () => {
      if (!isIOS) {
        window.removeEventListener(
          "beforeinstallprompt",
          handleBeforeInstallPrompt
        );
      }
    };
  }, [isIOS, setDeferredPrompt, setIsInstallable]);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the PWA installation");
        } else {
          console.log("User dismissed the PWA installation");
        }
        setDeferredPrompt(null);
        setIsInstallable(false);
      });
    }
  };

  if (isIOS) {
    return (
      <button
        onClick={() =>
          alert(
            `To install this app, tap the 'Share' button and then 'Add to Home Screen'`
          )
        }
        style={{
          marginLeft: "5px",
          cursor: "pointer",
          background: "#179624",
          border: "none",
          padding: "0px 20px",
          borderRadius: "10px",
        }}
      >
        <span className="footertag">Install App</span>
      </button>
    );
  }
  //console.log("isInstallable", isInstallable, "isIOS", isIOS);

  const Promostyles = {
    fontSize: "15px",
    fontFamily: "inter",
    fontWeight: 700,
    color: "#0d3862",
  };
  return (
    <div>
      {isInstallable ? (
        <>
          {/* <button style={props.style} onClick={handleInstallClick}>
            <span className="footertag">Install App</span>
          </button> */}
          {props.footerOnly ? (
            <button style={props.style} onClick={handleInstallClick}>
              <MdDownloadForOffline
                color="white"
                size={20}
                style={{ marginRight: "10px" }}
              />
              <span className="footertag">Install App</span>
            </button>
          ) : (
            <div className="space-sidebar mt-2">
              <div className="">
                <div className="sideBar-game">
                  <div
                    className={"link-div-Sportbook pt-2"}
                    onClick={() => {
                      handleInstallClick();
                    }}
                  >
                    <div className="promo-icon">
                      <MdDownloadForOffline color="#0D3862" size={30} />
                    </div>

                    <div className="Sport-count-name">
                      <span style={Promostyles}>Install App</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default FooterAppButton;
